import type { DentalXChangePlanBenefitInfo } from '@frontend/api-insurance-eligibility-report';
import { Benefit, BenefitLimit } from '../../../types/tuuthfairy-types';

export enum NetworkTypeEnum {
  IN_NETWORK = 'IN_NETWORK',
  OUT_OF_NETWORK = 'OUT_OF_NETWORK',
}

export type DentalXChangeReportFilters = {
  selectedNetwork: NetworkTypeEnum;
  coverageLevel: string[];
};
export type TuuthFairyTableType = BenefitLimit & Partial<Benefit>;

export type TablesDataType = {
  activeCoverage?: DentalXChangePlanBenefitInfo[];
  coInsurance?: DentalXChangePlanBenefitInfo[];
  coPayment?: DentalXChangePlanBenefitInfo[];
  deductible?: (DentalXChangePlanBenefitInfo | TuuthFairyTableType)[];
  benefitDescription?: DentalXChangePlanBenefitInfo[];
  exclusions?: DentalXChangePlanBenefitInfo[];
  limitation?: DentalXChangePlanBenefitInfo[];
  maximum?: (DentalXChangePlanBenefitInfo | TuuthFairyTableType)[];
  notCovered?: DentalXChangePlanBenefitInfo[];
  otherPayor?: DentalXChangePlanBenefitInfo[];
  otherBenefit?: DentalXChangePlanBenefitInfo[];
  outOfPocket?: DentalXChangePlanBenefitInfo[];
  otherSourceOfData?: DentalXChangePlanBenefitInfo[];
};
//Below type has column keys of dentalxchange and tuuthfairy data
export type DentalXChangeTableColumnKey = keyof DentalXChangePlanBenefitInfo;
export type TuuthFairyTableColumnKey = keyof TuuthFairyTableType;

export type TableColumnKeyType = DentalXChangeTableColumnKey | TuuthFairyTableColumnKey;
//Below type describes the table data based on vendor
export type TableDataType = DentalXChangePlanBenefitInfo | TuuthFairyTableType;

export enum Vendors {
  DentalXChange = 'DentalXChange',
  TuuthFairy = 'TuuthFairy',
}

//This TableFilterKey can be network key from the object which contains in-network/out-of-network values
export type TableFilterKey =
  | keyof Pick<DentalXChangePlanBenefitInfo, 'network'>
  | keyof Pick<TuuthFairyTableType, 'networkType' | 'networkName'>;

export type TuuthFairyAndDXCTableKeyTypes = 'maximum' | 'deductible';

export type TableDataTypeExcludeTuuthFairy = Exclude<keyof TablesDataType, TuuthFairyAndDXCTableKeyTypes>;

export interface SegregatedDataByNetworkType {
  in_network: TablesDataType;
  out_network: TablesDataType;
}
